// Locale strings of report 2.2 (driver-statement), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "كشف حساب السائق (حسب الرحلات)",
  title: "كشف حساب السائق (حسب الرحلات)",
  captain: "السائق",
  captainHint: "ابحث بالاسم أو الهاتف أو رقم السائق",
  captainId: "رقم السائق",
  captainIdHint: "أدخل رقم السائق",
  captainSearchForbidden: "لا تملك صلاحية البحث عن السائقين - أدخل رقم السائق مباشرة",
  captainSearchFailed: "تعذر البحث عن السائقين - أدخل رقم السائق مباشرة",
  captainNoResults: "لا يوجد سائق مطابق",
  chooseCaptainFirst: "اختر السائق ثم اضغط تطبيق",
  driverInfo: "بيانات السائق",
  name: "الاسم",
  phone: "الهاتف",
  driverAccount: "حساب السائق",
  carModel: "نموذج السيارة",
  plate: "رقم اللوحة",
  owner: "مالك السيارة",
  ownerAccount: "حساب المالك",
  walletBalance: "رصيد المحفظة في التطبيق",
  walletNote: "رصيد تشغيلي منفصل عن دفتر الأستاذ",
  openingBalance: "الرصيد الافتتاحي",
  closingBalance: "الرصيد الختامي",
  noCar: "لا توجد سيارة مسجلة",
  noLeaf: "لا يوجد حساب فرعي",
  tripsTitle: "الرحلات",
  otherTitle: "حركات أخرى",
  balancesTitle: "أرصدة حسابات السائق في دفتر الأستاذ",
  reconciliationTitle: "المطابقة مع دفتر الأستاذ",
  notesTitle: "ملاحظات",
  col: {
    trip: "الرحلة",
    date: "التاريخ",
    type: "النوع",
    paymentMethod: "طريقة الدفع",
    tripTotal: "إجمالي الرحلة",
    driverAccount: "حساب السائق",
    ownerAccount: "حساب المالك",
    companyShare: "إجمالي حصة الشركة",
    ownerShare: "حصة المالك",
    driverShare: "حصة السائق",
    bonus: "مكافأة",
    fine: "غرامة",
    netDriverShare: "صافي حصة السائق",
    cashReceived: "قبض نقداً",
    dueDriver: "مستحق على الشركة (سائق)",
    dueOwner: "مستحق على الشركة (مالك)",
    dueToCompany: "مستحق للشركة على السائق (نقدي)",
    reference: "رقم القيد",
    description: "البيان",
    account: "الحساب",
    debit: "مدين",
    credit: "دائن",
    remark: "ملاحظة",
    role: "النوع",
    opening: "الافتتاحي",
    closing: "الختامي",
    side: "طبيعة الرصيد",
  },
  detail: {
    bookingDate: "تاريخ الرحلة",
    settledAt: "تاريخ التسوية",
    companyCommission: "عمولة الشركة",
    companyKept: "حصة الشركة من النصف الثاني",
    discount: "الخصم",
    toPay: "المدفوع من الراكب",
    cashCollected: "النقد المقبوض من الراكب",
    percentages: "النسب (شركة / سائق / مالك)",
    journalEntry: "قيد الرحلة",
    journalDate: "تاريخ القيد",
    glEffect: "أثر القيد على حساب السائق",
    expectedEffect: "الأثر المتوقع (حصة السائق - النقد)",
    noEntry: "لا يوجد قيد رحلة",
    typeSource: "مصدر النوع",
  },
  typeSource: {
    entry: "من قاعدة قيد الرحلة",
    owner_row: "من سجل حصة المالك",
    percentages: "من نسب التوزيع",
    car: "من السيارة الحالية",
  },
  role: {
    leaf: "حساب السائق الفرعي",
    clearing: "تسوية السائقين (قيود قديمة برقم السائق)",
  },
  rec: {
    opening: "الرصيد الافتتاحي",
    rideDebit: "قيود الرحلات - مدين",
    rideCredit: "قيود الرحلات - دائن",
    otherDebit: "حركات أخرى - مدين",
    otherCredit: "حركات أخرى - دائن",
    computedClosing: "الرصيد الختامي المحسوب (الافتتاحي + الدائن - المدين)",
    closing: "الرصيد الختامي في دفتر الأستاذ",
    difference: "الفرق",
    reconciled: "مطابق",
    notReconciled: "غير مطابق",
    tripsEffect: "أثر الرحلات على رصيد السائق (المستحق للشركة بالسالب)",
  },
  flag: {
    notPosted: "غير مرحّلة إلى دفتر الأستاذ (خارج المجاميع)",
    inTrip: "مدرجة في سطر الرحلة",
    reversal: "قيد عكسي",
    reversed: "معكوس",
    mismatch: "أثر القيد لا يطابق التوزيع",
  },
  sheetDriver: "بيانات السائق",
  sheetTrips: "الرحلات",
  sheetOther: "حركات أخرى",
  sheetBalances: "الأرصدة والمطابقة",
  field: "البند",
  value: "القيمة",
  tripsCount: "عدد الرحلات",
  details: "التفاصيل",
};
